import { render, staticRenderFns } from "./TgNewsList.vue?vue&type=template&id=4a73d61b&"
import script from "./TgNewsList.vue?vue&type=script&lang=js&"
export * from "./TgNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports